import { render, staticRenderFns } from "./scan_alerts.vue?vue&type=template&id=1327ea62&"
import script from "./scan_alerts.vue?vue&type=script&lang=js&"
export * from "./scan_alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports